import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import LoadingPage from "./pages/LoadingPage";
import ResultPage from "./pages/ResultPage";
import FortuneLabMainPage from "./pages/fortuneLab/FortuneLabMainPage";
import FortuneLabLoadingPage from "./pages/fortuneLab/FortuneLabLoadingPage";
import FortuneLabResultPage from "./pages/fortuneLab/FortuneLabResultPage";
import FortuneLabPrivacyPolicyPage from "./pages/fortuneLab/FortuneLabPrivacyPolicyPage";
import ConsultMainPage from "./pages/consult/ConsultMainPage";
import ConsultResultPage from "./pages/consult/ConsultResultPage";
import PurchaseMainPage from "./pages/purchase/PurchaseMainPage";
import PurchaseResultPage from "./pages/purchase/PurchaseResultPage";
import TikTokInAppGuide from "./components/TikTokInAppGuide";

function App() {
  useEffect(() => {
    const resolveScrollableMain = (target: EventTarget | null) => {
      if (!(target instanceof HTMLElement)) {
        return null;
      }

      const container = target.closest(".main_container");
      const main = container?.querySelector("main");

      if (!(main instanceof HTMLElement)) {
        return null;
      }

      if (main.contains(target)) {
        return null;
      }

      if (main.scrollHeight <= main.clientHeight && main.scrollWidth <= main.clientWidth) {
        return null;
      }

      return main;
    };

    const handleWheel = (event: WheelEvent) => {
      const main = resolveScrollableMain(event.target);
      if (!main) {
        return;
      }

      event.preventDefault();
      if (event.deltaY) {
        main.scrollTop += event.deltaY;
      }

      if (event.deltaX) {
        main.scrollLeft += event.deltaX;
      }
    };

    let activeTouchMain: HTMLElement | null = null;
    let lastTouchY: number | null = null;

    const handleTouchStart = (event: TouchEvent) => {
      activeTouchMain = resolveScrollableMain(event.target);
      if (!activeTouchMain) {
        lastTouchY = null;
        return;
      }

      lastTouchY = event.touches[0]?.clientY ?? null;
    };

    const handleTouchMove = (event: TouchEvent) => {
      if (!activeTouchMain || lastTouchY === null) {
        return;
      }

      const currentY = event.touches[0]?.clientY;
      if (typeof currentY !== "number") {
        return;
      }

      event.preventDefault();
      activeTouchMain.scrollTop += lastTouchY - currentY;
      lastTouchY = currentY;
    };

    const resetTouchState = () => {
      activeTouchMain = null;
      lastTouchY = null;
    };

    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    window.addEventListener("touchend", resetTouchState);
    window.addEventListener("touchcancel", resetTouchState);

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", resetTouchState);
      window.removeEventListener("touchcancel", resetTouchState);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* 메인(루트) 경로 */}
        <Route path="/" element={<MainPage />} />

        {/* 카카오 인증 후 이동할 로딩 페이지 */}
        <Route path="/loading" element={<LoadingPage />} />

        {/* 결과 페이지 */}
        <Route path="/result" element={<ResultPage />} />

        {/* Fortune Lab 전용 경로 */}
        <Route path="/fortune-lab" element={<FortuneLabMainPage />} />
        <Route path="/fortune-lab/:trkId" element={<FortuneLabMainPage />} />
        <Route path="/fortune-lab/loading" element={<FortuneLabLoadingPage />} />
        <Route path="/fortune-lab/result" element={<FortuneLabResultPage />} />
        <Route path="/fortune-lab/privacy-policy" element={<FortuneLabPrivacyPolicyPage />} />

        {/* Consult 전용 경로 */}
        <Route path="/consult" element={<ConsultMainPage />} />
        <Route path="/consult/:trkId" element={<ConsultMainPage />} />
        <Route path="/consult/result" element={<ConsultResultPage />} />

        {/* Purchase 전용 경로 */}
        <Route path="/purchase/:trkId" element={<PurchaseMainPage />} />
        <Route path="/purchase/:trkId/result" element={<PurchaseResultPage />} />
      </Routes>
      <TikTokInAppGuide />
    </BrowserRouter>
  );
}

export default App;
